import { defineStore } from "pinia"
import axiosInstance from "@/http.js"
import { CLEARFXAI_API_URL, ADMIN_PATH, ADMIN2_PATH, QUOTEBOT_PATH, SECRETKEY } from "./index.js"
const axios = axiosInstance

export const useAdminStore = defineStore("admin", {
  state: () => ({}),
  actions: {
    // === BROKERS ===
    getBrokerList() {
      const url = `${CLEARFXAI_API_URL}/${ADMIN_PATH}/brokers`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    createBroker(payload) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN2_PATH}/broker_create`
      return axios.post(url, payload, {
        headers: {
          SECRETKEY
        }
      })
    },
    deleteBroker(id) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN2_PATH}/broker_delete/${id}`
      return axios.delete(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getBrokerDeletePreview(id) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN2_PATH}/broker_delete_preview/${id}`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },

    // === BANKS ===
    getBankList() {
      const url = `${CLEARFXAI_API_URL}/${ADMIN_PATH}/banks`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getBankIdList() {
      const url = `${CLEARFXAI_API_URL}/${ADMIN_PATH}/bank_id_list`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    createBankWithUser(payload) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN2_PATH}/bank_user_create`
      return axios.post(url, payload, {
        headers: {
          SECRETKEY
        }
      })
    },
    deleteBank(id) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN2_PATH}/bank_delete/${id}`
      return axios.delete(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },

    // === COMPANIES ===
    getCompanyList() {
      const url = `${CLEARFXAI_API_URL}/${ADMIN_PATH}/companies`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },

    // === USERS ===
    getUserList() {
      const url = `${CLEARFXAI_API_URL}/${ADMIN_PATH}/users`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    createClientUser(data) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN2_PATH}/user_create`
      return axios.post(url, data, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    updateUserPassword(new_password, email) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN_PATH}/user_reset_password/${email}`
      const data = {
        passwd: md5(new_password.trim())
      }
      return axios.put(url, data, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    deleteUser(data) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN_PATH}/user_lookuser_delete`
      return axios.delete(url, {
        params: {
          email: data.email,
          broker_email: data.email
        },
        headers: {
          Password: data.password,
          SECRETKEY: SECRETKEY
        }
      })
    },
    deleteUserById(id) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN2_PATH}/user_delete/${id}`
      return axios.delete(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    userEntityDelete(role, entityId) {
      const url = `${CLEARFXAI_API_URL}/${ADMIN2_PATH}/${role}/${entityId}/user`
      return axios.delete(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },

    // === BOT LINKING ===
    issueBotLinkingToken(companyId) {
      const url = `${CLEARFXAI_API_URL}/${QUOTEBOT_PATH}/company_bot_issue_token/${companyId}`
      return axios.post(url, {}, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    updateCompanyPhone(companyId, phone) {
      const url = `${CLEARFXAI_API_URL}/${QUOTEBOT_PATH}/company_bot_link_status/${companyId}`
      return axios.put(url, { phone: phone }, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    getCompanyBotLinkStatus(companyId) {
      const url = `${CLEARFXAI_API_URL}/${QUOTEBOT_PATH}/company_bot_link_status/${companyId}`
      return axios.get(url, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    revokeBotLinkingToken(companyId) {
      const url = `${CLEARFXAI_API_URL}/${QUOTEBOT_PATH}/company_bot_revoke_token/${companyId}`
      return axios.post(url, {}, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
    // Ends an established link. Revoking a token only cancels an invitation
    // nobody accepted yet; this is what takes access away from a linked user,
    // and the phone number is kept so re-inviting them is one click.
    unlinkCompanyBot(companyId) {
      const url = `${CLEARFXAI_API_URL}/${QUOTEBOT_PATH}/company_bot_unlink/${companyId}`
      return axios.post(url, {}, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },

    // No deep link: the backend reads it from the company's link record, which
    // is the only place that knows which bot the token belongs to.
    sendOnboardingEmail({ companyId, recipientEmail }) {
      const { INTERACTION_API_BASE_URL } = require("./interactions.js")
      const url = `${INTERACTION_API_BASE_URL}/email/onboarding`
      return axios.post(url, {
        company_id: companyId,
        recipient_email: recipientEmail
      }, {
        headers: {
          SECRETKEY: SECRETKEY
        }
      })
    },
  }
})
